import Container from './Container';

export const PlayerBio: React.FC<{ bio: string }> = ({ bio }) => <Container title='Biografia'>{bio}</Container>;

export default PlayerBio;
